import { Link } from "react-router-dom";
import { Crown } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0A0F1D] text-slate-300 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <span className="w-8 h-8 rounded-lg bg-[#3B1F6E] flex items-center justify-center"><Crown className="w-4 h-4 text-[#D97706]" /></span>
            <span className="font-serif-display text-xl font-semibold text-white">QRU Online</span>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed max-w-xs">Considered digital books and resources, delivered instantly. Crafted with care, published with intent.</p>
        </div>
        <div>
          <h4 className="text-xs font-bold uppercase tracking-widest text-[#D97706] mb-4">Explore</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/shop" className="hover:text-white transition-colors">Shop</Link></li>
            <li><Link to="/books" className="hover:text-white transition-colors">Books</Link></li>
            <li><Link to="/resources" className="hover:text-white transition-colors">Resources</Link></li>
            <li><Link to="/about" className="hover:text-white transition-colors">About</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs font-bold uppercase tracking-widest text-[#D97706] mb-4">Delivery</h4>
          <p className="text-sm text-slate-400 leading-relaxed">Every purchase is delivered as an instant, secure digital download. No shipping, no waiting.</p>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-slate-500">© {new Date().getFullYear()} QRU Online. All rights reserved.</div>
    </footer>
  );
}
